import * as axios from "axios";

export const SEND_API_MESSAGE_START = 'SEND_API_MESSAGE_START';
export const SEND_API_MESSAGE = 'SEND_API_MESSAGE';

export const sendMessage = (body) => dispatch => {
    dispatch({type: SEND_API_MESSAGE_START});

    const payload = axios.post('/api/send', body);
    dispatch({
        type: SEND_API_MESSAGE,
        payload
    });
};





// WEBPACK FOOTER //
// ./src/containers/widget/WidgetActions.js